export const TestCaseTypes = Object.freeze({
  FUNCTIONAL_TEST: 'Functional Test',
  INTEGRATION_TEST: 'Integration Test',
  PERFORMANCE_TEST: 'Performance Test',
  SECURITY_TEST: 'Security Test',
  UI_UX_TEST: 'UI/UX Test',
  API_TEST: 'API Test',
  });
  export const DEFAULT_TYPE = TestCaseTypes.FUNCTIONAL_TEST;